module.exports = __webpack_public_path__ + "img/ticket3_p.610702ac.svg";